<template>
  <div class="match-review-view">
    <div class="view-header">
      <h2>精彩赛事回顾</h2>
    </div>

    <div v-if="loading">Loading reviews...</div>
    <div v-if="error">{{ error }}</div>

    <div class="reviews-container">
      <div v-for="review in reviews" :key="review.name" class="review-card">
        <div @click="review.clicked = true">
          <img
            v-if="!review.clicked"
            :src="review.thumbnail"
            :alt="review.name"
            class="review-thumbnail"
          />
          <video v-else :src="review.video" controls class="review-thumbnail" />
        </div>
        <div class="review-title">{{ review.name }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { fetchMatchReviews } from '@/api/client.js'

const reviews = ref([])
const loading = ref(true)
const error = ref(null)

// 从后端API获取视频回顾数据
const fetchReviews = async () => {
  try {
    loading.value = true
    error.value = null
    
    // 使用统一的API客户端获取视频回顾数据
    const data = await fetchMatchReviews();
    
    // 格式化数据以匹配现有组件结构
    reviews.value = (data.results || data).map(item => ({
      name: item.name,
      thumbnail: item.thumbnail_url, // 后端提供的缩略图URL
      video: item.video_url,         // 后端提供的视频URL
      clicked: false
    }))
  } catch (err) {
    console.error('Failed to load match reviews:', err)
    error.value = 'Failed to load match reviews: ' + err.message
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  fetchReviews()
})
</script>

<style scoped>
.match-review-view {
  padding: 20px;
}

.view-header {
  margin-bottom: 20px;
}

.reviews-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.review-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
}

.review-card:hover {
  transform: translateY(-5px);
}

.review-thumbnail {
  width: 100%;
  aspect-ratio: 16/9; /* 保持 16:9 视频/封面比例 */
  object-fit: cover;  /* 填充容器，超出裁剪 */
  display: block;
}


.review-title {
  padding: 15px;
  font-weight: bold;
  background-color: #f9f9f9;
}
</style>
